import { CollectionListItem } from './collection-list-item'
import { ProviderDetail } from './provider-detail';
import { PortalUser } from './portal-user';

export class CollectionDetail extends CollectionListItem {
  public totalUsers: number;
  public users: PortalUser[];
  public providers: ProviderDetail[];
}